import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Bank-transfer backfill (superuser only on the backend).
// lookup is read-only; confirm writes the Beam payment rows for one slip.
const lookup = async (date, amount) => {
    return await axios.post(`${BACKEND_URL}/api/admin/transfer-backfill/lookup`, { date, amount });
};

const confirm = async (receiptId) => {
    return await axios.post(`${BACKEND_URL}/api/admin/transfer-backfill/confirm`, { receiptId });
};

const TransferBackfillService = {
    lookup,
    confirm,
};

export default TransferBackfillService;
